import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

import './LearnMoreTile.scss';

export interface ILearnMoreTile {
  icon: any;
  title: string;
  text: string;
  linkPath: string;
}

interface ILearnMoreTileProps {
  tile: ILearnMoreTile;
}

const LearnMoreTile = ({
  tile: { linkPath, icon, title, text },
}: ILearnMoreTileProps) => {
  if (title === 'My Spectrum App') {
    return (
      <div className="learn-more-tile">
        <div className="learn-more-tile__icon-wrapper">{icon}</div>
        <h3 className="learn-more-tile__title">{title}</h3>
        <p className="learn-more-tile__text">{text}</p>
        <div className="banner-ad-item__buttons">
          <a
            href="https://apps.apple.com/app/apple-store/id942608209?pt=431805&ct=getstarted_msa&mt=8"
            target="_blank"
            rel="noreferrer"
            className="button"
            title="Download on the Apple App Store"
            aria-label="Download on the Apple App Store"
          >
            <StaticImage
              src="../../../static/images/ads/badge-apple-app-store.png"
              alt=""
              width={150}
              height={50}
              placeholder="blurred"
            />
          </a>
          <a
            href=" https://play.google.com/store/apps/details?id=com.brighthouse.mybhn&referrer=utm_source%3Dgetstarted_msa%26utm_medium%3DPURL%26utm_term%3DMSA%26utm_content%3DMSA%26utm_campaign%3Dgetstarted_msa"
            target="_blank"
            rel="noreferrer"
            className="button"
            title="Download on the Google Play Store"
            aria-label="Download on the Google Play Store"
          >
            <StaticImage
              src="../../../static/images/ads/badge-google-play.png"
              alt=""
              width={142}
              height={42}
              placeholder="blurred"
            />
          </a>
        </div>
      </div>
    );
  } else {
    return (
      <a href={linkPath} className="learn-more-tile">
        <div className="learn-more-tile__icon-wrapper">{icon}</div>
        <h3 className="learn-more-tile__title">{title}</h3>
        <p className="learn-more-tile__text">{text}</p>
      </a>
    );
  }
};

export default LearnMoreTile;
